import React from 'react'

const Footer = () => {
    return (
        <div>
            <footer class="full_width">
                {/* <div class="footer-cta">
                    <div class="container">
                        <div class="pull-left left-text">
                            <h3>Have you any question or need any heujjjjnlp for work consultantion</h3>
                        </div>
                        <div class="pull-right btn-box">
                            <a href="#" class="cta-btn">Contact Us</a>
                        </div>
                    </div>
                </div> */}
                {/* <!-- Footer_Container Start--> */}
                <div class="ftr_mid full_width padtb_81_30">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ftr_txt_div mbot30">
                                <aside class="widget-footer">
                                    <div class="textwidget">
                                        <div class="footer-logo"><img
                                            src='/img/logo1.png' width={130} />
                                        </div>
                                        <p>We are a group of engineers with a sole aim to provide the best possible services at competitive prices.
                                        </p>
                                        <p><a class="ftr_readmore" href="/aboutUs">Read More</a></p>
                                        {/* <div class="ftr_social"><a href="#"><i aria-hidden="true" class="fa fa-facebook"></i></a><a href="#"><i
                                            aria-hidden="true" class="fa fa-twitter"></i></a><a href="#"><i aria-hidden="true"
                                                class="fa fa-google-plus"></i></a><a href="#"><i aria-hidden="true"
                                                    class="fa fa-linkedin"></i></a></div> */}
                                    </div>
                                </aside>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 mbot30 service_link_desk">
                                <aside class="widget-footer">
                                    <div class="textwidget">
                                        <div class="plft30">
                                            <h6>Our Projects</h6>
                                            <ul class="ftr_nav">
                                                <li><a href="/projects/hot-water-tank-for-LG">Hot Water Tank for LG</a></li>
                                                <li><a href="/projects/cold-water-tank-for-LG">Cold Water Tank for LG</a></li>
                                                <li><a href="/projects/composite-tester-for-LG">Composite Tester for LG</a></li>
                                                <li><a href="/projects/vacuum-chamber">Vacuum Chamber </a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </aside>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 mbot30 quick_link_mob">
                                <aside class="widget-footer">
                                    <div class="textwidget">
                                        <h6>Quick Links</h6>
                                        <ul class="ftr_nav">
                                            <li><a href="/">Home</a></li>
                                            <li><a  href="contactUs">Get Quote</a></li>
                                            <li><a href="/aboutUs">About Us</a></li>
                                            <li><a href="/news">News</a></li>
                                            <li><a href="/career">Career</a></li>
                                        </ul>
                                    </div>
                                </aside>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 mbot30 service_link_mob">
                                <aside class="widget-footer">
                                    <div class="textwidget">
                                        <div class="plft30">
                                            <h6>Our Services</h6>
                                            <ul class="ftr_nav">
                                                <li><a href="material_engineering.html">Material Enginnering</a></li>
                                                <li><a href="agriculture_processing.html">Agriculture Processing</a></li>
                                                <li><a href="mechanical_engineering.html">Mechanical Engineering</a></li>
                                                <li><a href="chemical_research.html">Chemical Research</a></li>
                                                <li><a href="power_energy.html">Power &#038; Energy</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </aside>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 mbot30 quick_link_desk">
                                <aside class="widget-footer">
                                    <div class="textwidget">
                                        <h6>Quick Links</h6>
                                        <ul class="ftr_nav">
                                            <li><a href="/">Home</a></li>
                                            <li><a  href="contactUs">Get Quote</a></li>
                                            <li><a href="/aboutUs">About Us</a></li>
                                            <li><a href="/news">News</a></li>
                                            <li><a href="/career">Career</a></li>
                                        </ul>
                                    </div>
                                </aside>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 mbot30 get_touch">
                                <aside class="widget-footer">
                                    <div class="textwidget">
                                        <h6>Get In Touch</h6>
                                        <ul class="ftr_nav get_in_touch">
                                            <li class="ftr_location_icon"><span class="txt-big">Technociv Technologies pvt. Ltd.</span> B-39, First Floor, B Block, Sector 64, Noida, UP-201301</li>
                                            <li class="ftr_phn_icon">+91 9999445570 / +91 99580 20570 / +91120-4573907</li>
                                            <li class="ftr_msg_icon"> info@technociv.com</li>
                                            {/* <li class="ftr_clock_icon">Monday &#8211; Friday : 800 &#8211; 1900</li> */}
                                        </ul>
                                    </div>
                                </aside>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Footer_Container End--> */}
                {/* <!-- Copyright Start--> */}
                <div class="ftr_btm full_width">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                <p> Copyright © Technociv Technologies 2025 - All rights reserved. </p>
                            </div>
                            {/* <div class="col-lg-6 col-md-6 col-sm-4 col-xs-12 text-right txt_center">
                                <p> Created by: Shtheme </p>
                            </div> */}
                        </div>
                    </div>
                </div>
                {/* <!-- Copyright End--> */}
            </footer>

        </div>
    )
}

export default Footer
